import { useTranslation } from 'react-i18next';

const items = [
  { key: 'what', icon: 'ri-information-line' },
  { key: 'how', icon: 'ri-flow-chart' },
  { key: 'review', icon: 'ri-star-line' },
  { key: 'shipping', icon: 'ri-truck-line' },
  { key: 'qc', icon: 'ri-search-eye-line' },
  { key: 'safety', icon: 'ri-shield-check-line' },
];

export default function InfoSections() {
  const { t } = useTranslation();

  return (
    <section id="info" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('info.sectionTitle')}</h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <div key={item.key} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} w-5 h-5 flex items-center justify-center`} />
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{t(`info.${item.key}Title`)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(`info.${item.key}Body`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}